import * as React from "react";
import type { SVGProps } from "react";
const SvgAiSparklesSmallGrey = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      fill="#2D3949"
      d="M6.625 10.333a1.33 1.33 0 0 0-.958-.958l-4.09-1.054a.333.333 0 0 1 0-.642l4.09-1.055a1.33 1.33 0 0 0 .958-.957l1.054-4.09a.333.333 0 0 1 .642 0l1.054 4.09a1.33 1.33 0 0 0 .958.958l4.09 1.054a.334.334 0 0 1 0 .642l-4.09 1.054a1.33 1.33 0 0 0-.958.958l-1.054 4.09a.334.334 0 0 1-.642 0z"
    />
    <path
      stroke="#2D3949"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.333}
      d="M13.333 2v2.667M14.667 3.333H12M2.667 11.333v1.333M3.333 12H2"
    />
  </svg>
);
export default SvgAiSparklesSmallGrey;
